import React from 'react';

import { Container } from './styles';

function BenefitActionConfig() {
  return (
    <Container>
      <h1>ok ok</h1>
    </Container>
  );
}

export default BenefitActionConfig;
